//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
let d=[[[0,"MapStatus",1,0],[0,"MapType",1,0]],[[["nEntitiesFromCurrentObject","entitiesFromCurrentObject"],"GetEntitiesFromCurrentObject",{},0,0],[["nEntitiesFromReplacementObject","entitiesFromReplacementObject"],"GetEntitiesFromReplacementObject",{},0,0],[["oldEntities","newEntities"],"SetMappedEntities",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.ParentEquivalencyMap = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.ParentEquivalencyMap";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.ParentEquivalencyMap.Status = Object.freeze({
    "Incomplete" : "Incomplete", "Tentative" : "Tentative", "Accepted" : "Accepted"});

SPLM.GeometricUtilities.ParentEquivalencyMap.Type = Object.freeze({
    "Undefined" : "Undefined", "UserDefined" : "UserDefined", "NameBased" : "NameBased", "Geometric" : "Geometric", "Inferred" : "Inferred", "Internal" : "Internal", "Inherited" : "Inherited", "Mixed" : "Mixed"});

export default SPLM;